import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { store } from 'CorePackage/MainModule/common/store';
import { addNoticeAction } from 'CorePackage/NotificationModule/actions/NoticeActions';
import { NoticeTypesEnum } from 'CorePackage/NotificationModule/enums/NoticeTypesEnum';
import { MessageTypesEnum } from 'CorePackage/NotificationModule/enums/MessageTypesEnum';
import { IResponseError } from 'APIPackage/MainModule/interfaces/IResponseError';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { coreSetLoading } from 'CorePackage/MainModule/actions/coreActions';
import { changeErpErknmClose } from 'APIPackage/SystemInoperabilityModule/services/endCheckingErpApi';

import { knmReload } from '../actions/knmActions';

export function useKnmEndErknmById() {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  const knmEndByErvk = useCallback(
    async (id: number) => {
      try {
        dispatch(coreSetLoading(true));
        const response = await changeErpErknmClose(id);

        dispatch(knmReload());

        return response;
      } catch (err) {
        const res = err as IResponseError;

        store.dispatch(
          addNoticeAction({
            renderContent: res.message,
            noticeType: NoticeTypesEnum.ERROR,
            messageType: MessageTypesEnum.KNM_NOT_AVAILABLE_FOR_PUBLISH,
          }),
        );
      } finally {
        dispatch(coreSetLoading(false));
      }
    },
    [dispatch],
  );

  return { knmEndByErvk };
}
